import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Handshake, Crown } from 'lucide-react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { TRADER_COLORS } from '../../utils/constants';
import { TRADER_FALLBACK_IMAGES } from '../../utils/constants';
function TraderLoyaltyPanel({ traders, profile, onUpdate }) {
    const { t } = useLanguage();

    const handleTraderLevelClick = (traderId, newLevel) => {
        const currentLevels = profile.traderLevels || {};
        const updatedProfile = {
            ...profile,
            traderLevels: { ...currentLevels, [traderId]: newLevel }
        };
        localStorage.setItem('tarkovProfile', JSON.stringify(updatedProfile));
        onUpdate(updatedProfile);
    };

    return (
        <div className="bg-[#09090b] border border-white/5 rounded-sm p-6 h-[860px] overflow-hidden flex flex-col shadow-xl relative">
            <h2 className="text-sm font-bold text-white uppercase tracking-widest mb-6 flex items-center gap-2 border-b border-white/5 pb-4">
                <Handshake className="w-4 h-4 text-emerald-500" />
                {t('trader_loyalty')}
            </h2>

            <div className="space-y-3 flex-1 overflow-y-auto custom-scrollbar pr-2">
                {traders.map((trader) => {
                    const traderId = trader.normalizedName || trader.name.toLowerCase();
                    const traderLevels = profile.traderLevels || {};
                    const currentLevel = traderLevels[traderId] || 1;
                    const maxLevel = traderId === 'fence' ? 2 : 4;
                    const isMaxLevel = currentLevel === maxLevel;

                    const tColor = TRADER_COLORS[traderId] || '#71717a';

                    return (
                        <div
                            key={trader.id}
                            className="relative flex items-center justify-between rounded-sm px-3 py-3 transition-all border"
                            style={{
                                borderColor: isMaxLevel ? '#eab308' : 'rgba(255,255,255,0.05)',
                                backgroundColor: isMaxLevel ? 'rgba(234, 179, 8, 0.05)' : '#0c0c0e',
                            }}
                        >
                            <div className="flex items-center gap-3">
                                <div className="relative">
                                    <LazyLoadImage
                                        src={trader.imageLink || TRADER_FALLBACK_IMAGES[trader.normalizedName] || TRADER_FALLBACK_IMAGES['default']}
                                        alt={trader.name}
                                        effect="blur"
                                        className="w-10 h-10 rounded-sm object-cover border"
                                        style={{
                                            borderColor: isMaxLevel ? '#eab308' : '#3f3f46',
                                            filter: isMaxLevel ? 'none' : 'grayscale(100%)'
                                        }}
                                    />
                                    {isMaxLevel && <Crown className="absolute -top-2 -right-2 w-4 h-4 text-yellow-500 fill-yellow-500 drop-shadow-md" />}
                                </div>

                                <div className="flex flex-col">
                                    <span
                                        className="font-bold text-xs uppercase tracking-wide"
                                        style={{ color: isMaxLevel ? '#eab308' : '#d4d4d8' }}
                                    >
                                        {t(`trader_${traderId}`)}
                                    </span>
                                    {traderId === 'fence' && (
                                        <span className="text-[9px] font-mono text-zinc-500">
                                            REP: {profile.fenceRep?.toFixed(2) || '0.00'}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="flex gap-1">
                                {[...Array(maxLevel)].map((_, idx) => {
                                    const level = idx + 1;
                                    const isActive = level <= currentLevel;

                                    return (
                                        <button
                                            key={idx}
                                            onClick={() => handleTraderLevelClick(traderId, level)}
                                            className="w-7 h-7 rounded-sm flex items-center justify-center text-xs font-black font-mono border transition-all"
                                            style={{
                                                backgroundColor: isActive ? `${tColor}40` : '#000000',
                                                borderColor: isActive ? tColor : '#27272a',
                                                color: isActive ? '#ffffff' : '#52525b',
                                            }}
                                        >
                                            {level}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default TraderLoyaltyPanel;